export default __webpack_public_path__ + "static/media/Optima.cf87624d.png";